import {
  SET_SCHOOL_SEARCH
} from '@/store/mutation-types'

const changeSearchValue = ({commit, dispatch}, payload) => {
  commit(SET_SCHOOL_SEARCH, payload)
}

export default {
  changeSearchValue,
}



// WEBPACK FOOTER //
// ./src/components/schools/store/actions.js